const HEADER_SELECTOR = 'header-component .menu-list__link';
const MEGA_SELECTOR = 'header-component .mega-menu__link';
const FOOTER_SELECTOR = '.shopify-section-group-footer-group .menu__item > a';
const MOBILE_CHILD_SELECTOR = '.menu-drawer__menu--childlist .menu-drawer__menu-item--child';
const HOVER_SELECTOR = `${MEGA_SELECTOR},${FOOTER_SELECTOR},${HEADER_SELECTOR}`;
const ADD_TO_CART_SELECTOR = [
  'form[action*="/cart/add"] button[type="submit"]',
  'form[action*="/cart/add"] input[type="submit"]',
  'button[name="add"]',
  'button[id*="AddToCart"]',
  'button[class*="add-to-cart"]',
  '.product-form__submit',
  '.quick-add__submit',
].join(',');

const favicon = document.querySelector('link[rel~="icon"], link[rel="apple-touch-icon"]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

if (favicon instanceof HTMLLinkElement && favicon.href) {
  const positioner = document.createElement('span');
  const ant = document.createElement('img');
  positioner.className = 'favicon-menu-peek-positioner';
  ant.className = 'favicon-menu-peek';
  ant.src = favicon.href;
  ant.alt = '';
  ant.decoding = 'async';
  ant.setAttribute('aria-hidden', 'true');
  positioner.appendChild(ant);
  document.body.appendChild(positioner);

  /** @type {Element | null} */
  let currentItem = null;
  let hideTimer = 0;
  let frameRequest = 0;
  let pendingX = -100;
  let pendingY = -100;

  /** @param {Element} item */
  function getTextRect(item) {
    const textElement = item.matches(HEADER_SELECTOR)
      ? item.querySelector('.menu-list__link-title') ?? item
      : item.matches(MOBILE_CHILD_SELECTOR)
        ? item.querySelector('.menu-drawer__menu-item-text') ?? item
        : item.matches(MEGA_SELECTOR)
          ? item.querySelector('.wrap-text') ?? item
          : item;
    const rects = textElement.getClientRects();
    const lastRect = rects.length ? rects.item(rects.length - 1) : null;
    return lastRect ?? item.getBoundingClientRect();
  }

  /** @param {number} x @param {number} y */
  function setPosition(x, y) {
    pendingX = Math.round(x);
    pendingY = Math.round(y);
    if (frameRequest) return;

    frameRequest = window.requestAnimationFrame(() => {
      positioner.style.transform = `translate3d(${pendingX}px,${pendingY}px,0)`;
      frameRequest = 0;
    });
  }

  /** @param {Element} item @param {'above' | 'right'} placement */
  function showAnt(item, placement) {
    if (reducedMotion.matches || (currentItem === item && positioner.classList.contains('is-visible'))) return;

    currentItem = item;
    const rect = getTextRect(item);
    const x = placement === 'above' ? rect.left + rect.width / 2 : rect.right + 12;
    const y = placement === 'above' ? rect.top - 7 : rect.top + rect.height / 2;
    setPosition(x, y);
    window.clearTimeout(hideTimer);
    positioner.classList.remove('is-hiding');
    positioner.classList.add('is-visible');
  }

  function hideAnt() {
    currentItem = null;
    window.clearTimeout(hideTimer);
    positioner.classList.remove('is-visible');
    positioner.classList.add('is-hiding');
    hideTimer = window.setTimeout(() => positioner.classList.remove('is-hiding'), 300);
  }

  /** @param {number} x @param {number} y */
  function splashFavicon(x, y) {
    if (reducedMotion.matches) return;

    const icon = document.createElement('img');
    const ring = document.createElement('span');
    icon.src = favicon.href;
    icon.alt = '';
    icon.className = 'favicon-cart-splash';
    icon.style.left = `${x}px`;
    icon.style.top = `${y}px`;
    ring.className = 'favicon-cart-ring';
    ring.style.left = `${x}px`;
    ring.style.top = `${y}px`;
    document.body.append(ring, icon);
    window.setTimeout(() => {
      icon.remove();
      ring.remove();
    }, 1000);
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(ADD_TO_CART_SELECTOR);
    if (!(button instanceof HTMLButtonElement || button instanceof HTMLInputElement)) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const rect = button.getBoundingClientRect();
    splashFavicon(rect.left + rect.width / 2, rect.top + rect.height / 2);
  }, true);

  document.addEventListener('mouseover', (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest(HOVER_SELECTOR);
    if (!item || currentItem === item) return;
    showAnt(item, item.matches(HEADER_SELECTOR) ? 'above' : 'right');
  }, true);

  document.addEventListener('mouseout', (event) => {
    if (!currentItem || !(event.target instanceof Element)) return;
    if (event.target !== currentItem && !currentItem.contains(event.target)) return;
    if (event.relatedTarget instanceof Node && currentItem.contains(event.relatedTarget)) return;
    hideAnt();
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' || !(event.target instanceof Element)) return;
    const child = event.target.closest(MOBILE_CHILD_SELECTOR);
    if (child) showAnt(child, 'right');
  }, { passive: true, capture: true });

  window.addEventListener('resize', () => {
    if (currentItem) hideAnt();
  }, { passive: true });

  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches && currentItem) hideAnt();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (currentItem && event.target instanceof Element && event.target.contains(currentItem)) hideAnt();
  });
}